<div class="dialog-container">

  <div class="title" [innerHTML]="'JointInfo.Title' | translate | safe:'html'"></div>
  <div class="sub-title" [innerHTML]="'JointInfo.SubTitle' | translate | safe:'html'"></div>
  <button [mat-dialog-close]="true">
    <span class="symbol"> &larr; </span>
    {{ 'JointInfo.Continue' | translate }}
  </button>
</div>
